import {
    Icon28UserOutline,
    Icon28MessageOutline,
    Icon24BrowserBack,
    Icon20ShoppingCartOutline,
    Icon24Cancel,
    Icon20CloudOutline
} from "@vkontakte/icons";
import Fancybox from "../assets/fancybox";
import axios from "axios";
import {
    Avatar,
    Button,
    ButtonGroup, Cell, List,
    Chip,
    PanelHeader,
    PanelHeaderButton, RichCell,
    SplitCol,
    SplitLayout, Header, ModalPageHeader, ModalRoot, ModalPage,
    Tabs,
    TabsItem
} from "@vkontakte/vkui";
import React from "react";
import {Icon28Camera} from '@vkontakte/icons';
import * as constants from "../assets/constants";
import {Icon28ErrorCircleOutline} from '@vkontakte/icons';
import {Icon28InfoCircleOutline} from '@vkontakte/icons';

import {AdaptivityContext} from "../assets/constants";
import moment from "moment";
import CartApi from "../api/CartApi";
import FileSender from "./fileSender";
import BaseApi from "../api/BaseApi";
import BaseComponent from "../components/BaseComponent";

class SaleDocForm extends BaseComponent {

    state = {
        load_files: false,
        items_monitoring: {},
        currentFile: {},
        emails: [],
        currentTab: 'items'
    }

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        super.componentDidMount()
        const data = localStorage.getItem(constants.photo_ffc_items_key)
        if (data && data !== "undefined") {
            const items = JSON.parse(data)
            this.setState({items_monitoring: items})
            console.log(items)
        }
    }

    getDoc = (id) => {
        BaseApi.post('?app=saledocs&act=showOne', {id: id}
        ).then((response) => {
            if (response.data.doc_data) {
                this.props.select_doc(response.data, this.props.current_club)
            }
        })

    }


    invoiceTimeId = 0

    getInvoiceByRequest = () => {

        this.setState({load_files: true})


        BaseApi.post('?app=saledocs&act=createInvoiceRequest', {doc_id: this.props.current_doc.doc_data.id}).then((response) => {

            if (response.data.incorrect_prices || (response.data.error && !response.data.id)) {
                this.setState({load_files: false})
                window.postMessage({
                    type: 'error',
                    text: response.data.error || 'Скачивание счета невозможно — не корректно проставлены цены',
                    timeout: 8000
                })
                return
            }

            const invoice_req_id = response.data.id

            clearInterval(this.invoiceTimeId);
            this.invoiceTimeId =
                setInterval(() => {

                    BaseApi.post('?app=saledocs&act=getInvoiceRequest', {req_id: invoice_req_id}).then((response2) => {
                        if (response2.data.filename != undefined) {
                            clearInterval(this.invoiceTimeId)
                            this.setState({load_files: false})
                            this.getDoc(this.props.current_doc.doc_data.id)
                        }
                        if (response2.data.error != undefined) {
                            const {error} = response2.data

                            clearInterval(this.invoiceTimeId)
                            this.setState({load_files: false})
                            window.postMessage({
                                type: 'error',
                                text: `Ошибка формирования счета: "${error}" обратитесь к Вашему менеджеру`,
                                timeout: 5000
                            })
                        }
                    })

                }, 1000);
        })

    }

    exportToWebservice = (doc_id) => {
        BaseApi.get('/?app=saledocs&act=exportDocToWebService&doc_id=' + doc_id).then(() => setTimeout(() => this.getDoc(doc_id), 4000))
    }
    getJson = (doc_id) => {

        window.open(this.props.base_url + '/?app=saledocs&act=exportDocToWebService&getJson=1&doc_id=' + doc_id, 'blank_')
    }

    formatMetaValue = (value) => {
        if (value === null || value === undefined || value === '') {
            return 'Не указано';
        }
        return String(value);
    }

    formatBoolMetaValue = (value) => {
        if (value === null || value === undefined || value === '') {
            return 'Не указано';
        }
        if (value === 1 || value === '1' || value === true || value === 'Истина' || value === 'true') {
            return 'Да';
        }
        if (value === 0 || value === '0' || value === false || value === 'Ложь' || value === 'false') {
            return 'Нет';
        }
        return String(value);
    }

    isEndClientDelivery = (value) => {
        return value === 1 || value === '1' || value === true || value === 'Истина' || value === 'true';
    }

    renderDeliveryTab = (meta) => {
        const endClientDelivery = this.isEndClientDelivery(meta?.типДоставкиДоКонечногоКлиента);

        const deliveryFields = [
            {label: 'Доставка до конечного клиента', value: this.formatBoolMetaValue(meta?.типДоставкиДоКонечногоКлиента)},
        ];

        if (endClientDelivery) {
            deliveryFields.push(
                {label: 'Плановая дата отгрузки', value: this.formatMetaValue(meta?.ПлановаяДатаОтгрузки)},
                {label: 'Адрес доставки', value: this.formatMetaValue(meta?.Адрес?.string_value)},
                {label: 'Дата доставки клиента', value: this.formatMetaValue(meta?.датаДоставкиДоКонечногоКлиента)},
                {label: 'Телефон адреса доставки', value: this.formatMetaValue(meta?.телАдресаДоставки)},
                {label: 'Дополнение к адресу доставки', value: this.formatMetaValue(meta?.дополнениеАдресуДоставки)},
                {label: 'Наименование тарифа доставки', value: this.formatMetaValue(meta?.НаименованиеТарифаДоставки)},
            );
        }

        return (
            <List>
                <Header mode="primary">Доставка</Header>
                {deliveryFields.map((field) => (
                    <Cell key={field.label} before={<Icon28InfoCircleOutline/>}
                          after={field.value} multiline>
                        <Chip removable={false}>{field.label}</Chip>
                    </Cell>
                ))}
            </List>
        );
    }

    render() {
        let images_url = this.props.base_url.replace("frontend/", '');

        let monitoring_photo = this.props.current_doc && this.state.items_monitoring[this.props.current_doc.doc_data.id] ? this.state.items_monitoring[this.props.current_doc.doc_data.id] : {
            hasImage: false,
            isConfirm: false
        }

        let comments = '';
        if (this.props.current_doc) {
            this.props.current_doc.meta_data.comment.map((el, i) => {
                comments += el.body.replace('<br/>', '\r\n')
            })

            const {meta} = this.props.current_doc.doc_data
            if (meta.confirmFFC && meta.confirmFFC.image) {
                monitoring_photo = {
                    hasImage: true,
                    isConfirm: true,
                    mainImage: meta.confirmFFC.image,
                    thumb: meta.confirmFFC.image,
                    date: moment(meta.confirmFFC.date, 'DD.MM.YYYY').toDate(),
                    numdoc: meta.confirmFFC.numdoc
                }
            }


        }
        let accessToInvoices = false

        if (this.props.current_doc && this.props.current_doc.doc_data.is_head != '1'
            && (this.props.current_user["meta"]["rules"]["admin"] == "1" || this.props.current_user["meta"]["rules"]["get_invoice"] == "1") && this.props.current_doc['doc_data']['status'] != 0) {
            accessToInvoices = true;
        }
        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>
                <ModalPage
                    id={constants.MODAL_SEND_EMAILS}
                    onClose={this.modalBack}
                    settlingHeight={100}
                    style={{}}
                    header={
                        <ModalPageHeader className="sclads"
                                         right={<PanelHeaderButton
                                             onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                        >
                            Получить
                            счет {this.state.currentFile && this.state.currentFile.meta ? this.state.currentFile.date + '.' + this.state.currentFile.meta.filename.split('.')[1] : ''}
                        </ModalPageHeader>
                    }
                >
                    <FileSender
                        base_url={this.props.base_url}
                        file={this.state.currentFile}
                        emails={this.state.emails}
                        close={() => this.setActiveModal(null)}
                        id={this.props.current_doc ? this.props.current_doc.doc_data.id : null}
                    />
                </ModalPage>
            </ModalRoot>
        )


        return (this.props.current_doc ?
            <SplitLayout modal={modals}>
                <SplitCol>
                    <PanelHeader style={{whiteSpace: "pre-line"}} before={this.props.show_back && this.props.hideDoc ?
                        <PanelHeaderButton onClick={() => this.props.hideDoc(this.props.current_club)}
                                           key="cmd_back_doc"><Icon24BrowserBack/></PanelHeaderButton> : ''}>

                        {this.props.current_doc.meta_data.title}
                    </PanelHeader>
                    <List>
                        <Header
                            mode="primary">
                            Реквизиты заказа
                        </Header>
                        <Cell before={<Icon28InfoCircleOutline/>}
                              after={this.props.current_doc.doc_data.NomerDocKIS}><Chip
                            removable={false}>Документ</Chip></Cell>
                        <Cell before={<Icon28InfoCircleOutline/>}
                              after={this.props.current_doc.doc_data.meta.Дата}><Chip
                            removable={false}>Дата</Chip></Cell>
                        <Cell before={<Icon28UserOutline/>}
                              after={this.props.current_doc.doc_data.meta.Контрагент.Представление}><Chip
                            removable={false}>Клиент</Chip></Cell>
                        <Cell before={<Icon28InfoCircleOutline/>}
                              after={this.props.current_doc.doc_data.meta.Адрес.string_value || 'Не указан'}><Chip
                            removable={false}>Адрес</Chip></Cell>

                        {this.props.current_doc.doc_data.invoices && accessToInvoices ?
                            <Cell before={<Icon28InfoCircleOutline/>}
                                  after={<div>
                                      <Button loading={this.state.load_files}
                                              onClick={this.getInvoiceByRequest}>{this.state.load_files ? 'Запрашиваем счет' : 'Запросить счет'}</Button>
                                      {!this.props.current_doc.doc_data.incorrect_prices &&
                                          <>
                                              <hr/>
                                              {this.props.current_doc.doc_data.invoices.map((inv, z) => (
                                                  <Button size="m" mode="outline"
                                                          onClick={() => this.showSendEmails(inv)}>{'Получить счет ' + inv.date + '.' + inv.meta.filename.split('.')[1]}</Button>
                                              ))}
                                          </>
                                      }</div>}><Chip
                                removable={false}>Файлы</Chip></Cell>

                            : ''}

                        {this.props.current_user["meta"]["rules"]["admin"] == "1" &&
                            <Cell before={<Icon20CloudOutline/>}
                                  after={<div style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "space-evenly",
                                      height: "120px"
                                  }}>
                                      <Button onClick={() => this.getJson(this.props.current_doc.doc_data.id)}>Скачать
                                          json</Button>
                                      <Button
                                          onClick={() => this.exportToWebservice(this.props.current_doc.doc_data.id)}>Выгрузить
                                          заказ в 1С</Button>
                                  </div>}>
                                <Chip removable={false}>Экспорт в 1С</Chip>
                            </Cell>}
                        {this.props.current_doc.doc_data.meta.СкладПолучения && this.props.current_doc.doc_data.meta.СкладПолучения.Представление ?
                            <Cell before={<Icon28MessageOutline/>}
                                  after={this.props.current_doc.doc_data.meta.СкладПолучения.Представление}><Chip
                                removable={false}>Филиал</Chip></Cell> : ''}
                        {this.props.current_doc.doc_data.meta.Комментарий ? <Cell before={<Icon28MessageOutline/>}
                                                                                  after={this.props.current_doc.doc_data.meta.Комментарий}><Chip
                            removable={false}>Комментарий</Chip></Cell> : ''}
                        <Cell before={<Icon28InfoCircleOutline/>}
                              after={this.props.current_doc.doc_data['1CErrors']}><Chip removable={false}>Статус</Chip></Cell>
                        {comments ? <Cell before={<Icon28ErrorCircleOutline/>} multiline={true} after={comments}><Chip
                            removable={false}>Проблемы проведения</Chip> </Cell> : ''}
                        {this.props.current_club && (this.props.current_doc.doc_data.is_firm_fit == '1'
                            || this.props.current_doc.doc_data.is_primavera == '1'
                            || this.props.current_doc.doc_data.is_betta_ == '1'
                            || this.props.current_doc.doc_data.is_lq == '1'
                        ) ?
                            <Cell before={<Icon28Camera/>} multiline={true}
                                  after={<Fancybox key={'SaleDocsMonitoringFancyBox'}>
                                      <div className="sale-doc-form_monitoring-avatar">
                                          {monitoring_photo.isConfirm && monitoring_photo.hasImage ?

                                              <div>
                                                  <a data-fancybox={'gallery' + this.props.current_doc.doc_data.id}
                                                     href={images_url + monitoring_photo.mainImage.replace(images_url, '')}>
                                                      {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                               size={AdaptivityContext.isMobile ? 80 : 160}
                                                               src={monitoring_photo.thumb}/>}
                                                  </a>
                                                  <Cell before={<Chip removable={false}>Номер
                                                      заказа</Chip>}>{monitoring_photo.numdoc}
                                                  </Cell>
                                                  <Cell before={<Chip removable={false}>Дата
                                                      заказа</Chip>}>
                                                      {moment(monitoring_photo.date).format('DD.MM.YYYY')}
                                                  </Cell>

                                              </div>
                                              :
                                              <Avatar mode="image" style={{borderRadius: '5%'}}

                                                      size={AdaptivityContext.isMobile ? 80 : 160}
                                                      src={images_url + constants.EMPTY_IMG}/>
                                          }
                                      </div>
                                  </Fancybox>}>
                                <Chip removable={false}>Фото</Chip> </Cell> : ''}

                        {this.props.current_user["meta"]["rules"]["admin"] == "1" &&
                            <Cell before={<Icon20ShoppingCartOutline/>}
                                  after={<Button onClick={() => this.copyOrder()}>Повторить заказ</Button>}>
                                <Chip removable={false}>Товары</Chip></Cell>}


                    </List>
                    {this.props.current_doc.doc_data.childs ? <List>
                        <Header
                            mode="primary">
                            Заказы в 1С
                        </Header>
                        {
                            this.props.current_doc.doc_data.childs.map((child, childIndex) => (
                                <Cell onClick={() => this.getDoc(child.id)} before={child.NomerDocKIS} after={<Chip
                                    removable={false}>{child['1CStatusName']}</Chip>}></Cell>

                            ))
                        }
                    </List> : ''}
                    <Tabs>
                        <TabsItem
                            selected={this.state.currentTab === 'items'}
                            onClick={() => this.setState({currentTab: 'items'})}
                        >Товары</TabsItem>
                        <TabsItem
                            selected={this.state.currentTab === 'delivery'}
                            onClick={() => this.setState({currentTab: 'delivery'})}
                        >Доставка</TabsItem>
                    </Tabs>
                    {this.state.currentTab === 'items' && <>
                        <Header
                            mode="primary">
                            Состав заказа
                            / {this.props.current_doc.doc_items.length} {constants.inducement(this.props.current_doc.doc_items.length, 'товар', 'товара', 'товаров',)}
                        </Header>
                        <List><Fancybox>
                            {this.props.current_doc.doc_items.length > 0 ?
                                [
                                    this.props.current_doc.doc_items.map((item, index) => {
                                            if (item.img) {
                                                item.img = item.img.replace("\/\/", "\/")
                                            }
                                            return [<RichCell multiline={true}
                                                              before={[<a data-fancybox={'galleryCart' + item.id}
                                                                          href={images_url + item.img}>
                                                                  {<Avatar mode="image" style={{borderRadius: '5%'}} size={52}
                                                                           src={images_url + item.img}/>}</a>

                                                              ]}

                                                              caption={
                                                                  [<div
                                                                      dangerouslySetInnerHTML={{__html: (item.sclad_id == -1 && item.isTariff != 1 ? '<span class="red">Под заказ</span><br>' : '') + (item.sclad_name ?? '')}}>
                                                                  </div>,
                                                                      <small
                                                                          style={{display: "block"}}><b>{item.series_code ? 'Серия: ' + item.series_code : ''}</b></small>,
                                                                      <small className="red"
                                                                          style={{display: "block", color: "red"}}><b>{item.date_in ? 'Планируемая дата поступления на склад: ' + item.date_in : ''}</b></small>
                                                                  ]}
                                                              afterCaption={[<div
                                                                  style={{
                                                                      textAlign: "center",
                                                                      fontSize: "18px"
                                                                  }}>{item.quantity + item.unit_name} </div>

                                                              ]}


                                            >
                                                <span onClick={() => BaseApi.openProductSearch(item.name)}>{item.name}</span>
                                            </RichCell>,
                                                <RichCell multiline={true}><ButtonGroup mode="horizontal" gap="l" stretched>
                                                    <Button mode="primary" before="Цена:" stretched size="l" mode="secondary"
                                                            after={item.discount != undefined && item.discount != 0 ? '-' + (item.discount.toFixed(2).replace('.00', '')) + '%' : ''}
                                                            style={{textAlign: "center", minWidth: "120px"}}>
                                                        {item.discount != undefined && item.discount != 0 ?
                                                            <span style={{
                                                                display: 'block',
                                                                textDecoration: 'line-through',
                                                                color: 'red',
                                                                fontSize: 'smaller',
                                                                fontWeight: 300
                                                            }}>
                                                                        {(item.price * 1).toFixed(2) + constants.currency_char}
                                                                        </span> : ''}
                                                        {(item.price * 1 - (item.discount != undefined && item.discount != 0 ? (item.price / 100 * item.discount) : 0)).toFixed(2) + constants.currency_char}
                                                    </Button>
                                                    <Button mode="primary" stretched before="Сумма:" size="l" mode="secondary"
                                                            after={item.discount != undefined && item.discount != 0 ? '-' + (item.discount.toFixed(2).replace('.00', '')) + '%' : ''}
                                                            style={{textAlign: "center", minWidth: "120px"}}>
                                                        {item.discount != undefined && item.discount != 0 ?
                                                            <span style={{
                                                                display: 'block',
                                                                textDecoration: 'line-through',
                                                                color: 'red',
                                                                fontSize: 'smaller',
                                                                fontWeight: 300
                                                            }}>
                                                                        {(item.price * 1 * item.quantity).toFixed(2) + constants.currency_char}
                                                                        </span> : ''}
                                                        {((item.price * 1 - (item.discount != undefined && item.discount != 0 ? (item.price / 100 * item.discount) : 0)) * item.quantity).toFixed(2) + constants.currency_char}
                                                    </Button>


                                                </ButtonGroup></RichCell>]
                                        }
                                    )
                                ] : <Cell>Корзина пуста</Cell>}
                        </Fancybox>
                        </List>
                    </>}
                    {this.state.currentTab === 'delivery' && this.renderDeliveryTab(this.props.current_doc.doc_data.meta)}

                </SplitCol>
            </SplitLayout> : '')

    }

    getInvoiceFile = (inv) => {
        if (!AdaptivityContext.isMobile) {
            window.open(inv.meta.filename)
        } else {

            const body = new FormData()

            body.append('id', this.props.current_doc.doc_data.id)

            axios.post(this.props.base_url + '?app=saledocs&act=sendFileToEmail', body,
                {
                    withCredentials: true

                }
            ).then((response) => {
                if (response.data.success) {
                    window.postMessage({type: 'success', text: 'Письма со счетом успешно отправлены', timeout: 2000})
                }
            })


        }
    }

    copyOrder = () => {
        this.props.current_doc.doc_items.map((item) => {
            if (item.sclad_old) {
                item.sclad_id = item.sclad_old.id
            }
            CartApi.addOrEdit(item)
        })
        CartApi.saveItems(() => window.postMessage("goToCart"))
    }

    showSendEmails = (inv) => {


        const body = new FormData()

        body.append('id', this.props.current_doc.doc_data.id)

        axios.post(this.props.base_url + '?app=saledocs&act=getEmails', body,
            {
                withCredentials: true

            }
        ).then((response) => {


            if (response.data.emails) {
                this.setState({emails: response.data.emails})
            }

            this.setState({currentFile: inv})
            this.setActiveModal(constants.MODAL_SEND_EMAILS)

        })


    }
}

export default SaleDocForm